import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { postDataWithParams } from "../../../service/Service";
import NumberFormatting from "../../helper/NumberFormatting";
import {
  getOperationalSubmissionById,
  operationalSubmissionActions,
  postOperationalSubmission,
} from "../../../redux/reducer/operationalSubmission/operationalSubmissionReducer";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#ddd",
    borderBottom: "1px solid #D1CDCD",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminOperationalSubmissionTambah() {
  // Navigate
  const navigate = useNavigate();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);

  // Local State
  const [formData, setFormData] = useState({
    totalPriceSubmission: 0,
  });
  const [goodsOperational, setGoodsOperational] = useState([]);
  const [operationalDetails, setOperationalDetails] = useState([]);

  useEffect(() => {
    handleAddOperationalDetails();
  }, []);

  useEffect(() => {
    let body = {};
    let params = {
      paginate: false,
    };
    postDataWithParams("/master/goods-operational/search", token, body, params)
      .then((res) => {
        if (res.data.status === 200) {
          setGoodsOperational([...res.data.data.docs]);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err.response.message);
      });
  }, []);

  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handling Order Details
  const handleOperationalDetails = (index) => (e) => {
    const newItems = [...operationalDetails];
    newItems[index][e.target.name] = e.target.value;
    newItems[index]["price"] = parseInt(newItems[index]["order"]);
    let x = goodsOperational.findIndex(
      (item) => item._id === newItems[index]?.goodsOperationalId
    );
    if(x > -1) {
        newItems[index]["price"] =
          newItems[index]["quantity"] * goodsOperational[x]?.priceOfGoods;
    }else {
        newItems[index]["price"] = 0
    }

    setFormData({
      ...formData,
      totalPriceSubmission: newItems.reduce(
        (acc, cur) => parseInt(acc) + parseInt(cur.price),
        0
      ),
    });
    setOperationalDetails(newItems);
  };

  const handleAddOperationalDetails = () => {
    setOperationalDetails((prevItems) => [
      ...prevItems,
      {
        goodsOperationalId: "",
        quantity: 0,
        price: 0,
        status: false,
        description: "",
      },
    ]);
  };

  const handleDeleteOperationalDetails = (value) => {
    let deletedData = [];
    for (let i = 0; i < operationalDetails.length; i++) {
      if (i !== value) {
        deletedData.push(operationalDetails[i]);
      }
    }
    setOperationalDetails(deletedData);
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          data: {
            operationalDetails: operationalDetails,
            totalPriceSubmission: formData.totalPriceSubmission,
          },
          token: token,
        };
        dispatch(postOperationalSubmission(data)).then((res) => {
          if (res.payload.status === 201) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getOperationalSubmissionById(dataGetById)).then(
              (result) => {
                dispatch(
                  operationalSubmissionActions.addOperationalSubmission(
                    result.payload.data
                  )
                );
                toast.success(res.payload.message);
                navigate("/admin/pengajuan-operasional");
              }
            );
          }
        });
      } else {
        return;
      }
    });
  };

  const operationalDetailsColumn = [
    "BARANG",
    "JUMLAH",
    "HARGA",
    "AKSI",
  ];

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          BUAT PENGAJUAN OPERASIONAL
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
          onSubmit={handleSubmitAll}
        >
          <Typography
            marginTop={1}
            marginBottom={1}
            fontSize={14}
            color={"#2e473f"}
            variant="h6"
          >
            DETAIL BARANG OPERATIONAL
          </Typography>
          <table
            style={{
              width: "100%",
              marginBottom: "10px",
              borderCollapse: "collapse",
              borderRadius: "1em",
              overflow: "hidden",
            }}
          >
            <thead>
              {operationalDetailsColumn.map((item, index) => {
                return (
                  <td className={styles.tableHeader} key={index}>
                    {item}
                  </td>
                );
              })}
            </thead>
            <tbody>
              {operationalDetails.length > 0 &&
                operationalDetails.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td
                        className={styles.tableCell}
                        style={{ width: "400px" }}
                      >
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            select
                            InputLabelProps={{ shrink: true }}
                            required
                            size="small"
                            error={false}
                            name="goodsOperationalId"
                            onChange={handleOperationalDetails(index)}
                            value={item.goodsOperationalId}
                            fullWidth
                            variant="outlined"
                            SelectProps={{
                              MenuProps: {
                                style: {
                                  height: "300px",
                                },
                              },
                            }}
                            style={{
                              maxWidth: "400px",
                              background: "white",
                              marginRight: "10px",
                            }}
                          >
                            {goodsOperational.length > 0 ? (
                              goodsOperational.map((data, index) => (
                                <MenuItem value={data._id} key={index}>
                                  {data.nameOfGoods}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem value="">Data kosong</MenuItem>
                            )}
                          </TextField>
                        </FormControl>
                      </td>

                      <td
                        className={styles.tableCell}
                        style={{ width: "350px" }}
                      >
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            required
                            size="small"
                            InputProps={{
                              inputComponent: NumberFormatting,
                              endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                              ),
                            }}
                            error={false}
                            name="quantity"
                            id={index}
                            onChange={handleOperationalDetails(index)}
                            value={item.quantity}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td
                        className={styles.tableCell}
                        style={{ width: "200px" }}
                      >
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ readOnly: true }}
                            required
                            size="small"
                            error={false}
                            name="price"
                            id={index}
                            onChange={handleOperationalDetails(index)}
                            value={item.price.toLocaleString("id", {
                              style: "currency",
                              currency: "IDR",
                            })}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            width: "100px",
                          }}
                        >
                          <AddIcon
                            className={styles.actionButtonEdit}
                            onClick={() => handleAddOperationalDetails()}
                          />
                          {operationalDetails.length > 1 && index !== 0 ? (
                            <RemoveIcon
                              className={styles.actionButtonEdit}
                              onClick={() =>
                                handleDeleteOperationalDetails(index)
                              }
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <Divider />

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TOTAL HARGA
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true, style: { background: "white" } }}
              required
              size="small"
              error={false}
              name="totalPriceSubmission"
              onChange={handleChange}
              value={formData.totalPriceSubmission.toLocaleString("id", {
                style: "currency",
                currency: "IDR",
              })}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button variant="contained" type="submit">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/admin/pengajuan-operasional")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
